import { render, staticRenderFns } from "./BtnBlock.vue?vue&type=template&id=43ee71e6&"
import script from "./BtnBlock.vue?vue&type=script&lang=js&"
export * from "./BtnBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports